(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6766],{

/***/ 31039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/offshore/contact-us/index.js + 1 modules
var contact_us = __webpack_require__(56133);
;// CONCATENATED MODULE: ./pages/sg/contact-us/data.json
var data_namespaceObject = JSON.parse('{"country":"Singapore","banner_image":"/assets/images/common/contact-us/banner-contact_us.png","title":"Contact Us","breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Contact Us","uri":"/contact-us"}],"contacts":[{"icon":"/assets/icons/phone-circle.svg","altText":"phone-circle","description":"(+65) 3138 1666"},{"icon":"/assets/icons/location-circle.svg","altText":"location-circle","description":"68 Circular road, #02-01 Singapore (049422), Singapore"}]}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/sg/contact-us/index.js






var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* default */.Z, {
    locationRouter: "sg",
    page: data === null || data === void 0 ? void 0 : data.page,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(head["default"], {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "alternate",
        href: "".concat("https://betasgo.bbcincorp.com", "/hk/contact-us"),
        hrefLang: "en-hk"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "alternate",
        href: "".concat("https://betasgo.bbcincorp.com", "/sg/contact-us"),
        hrefLang: "en-sg"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "alternate",
        href: "".concat("https://betasgo.bbcincorp.com", "/offshore/contact-us"),
        hrefLang: "en-us"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "alternate",
        href: "".concat("https://betasgo.bbcincorp.com", "/offshore/contact-us"),
        hrefLang: "en"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "alternate",
        href: "".concat("https://betasgo.bbcincorp.com", "/vn/contact-us"),
        hrefLang: "en-vi"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(contact_us/* default */.Z, {
      data: data_namespaceObject
    })]
  });
}

/***/ }),

/***/ 56836:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sg/contact-us",
      function () {
        return __webpack_require__(31039);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,9593,9885,9973,9669,4090,9738,7447,6133,9774,2888,179], function() { return __webpack_exec__(56836); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);